import { Theme, css } from '@emotion/react';

export const cardRootStyle = ({ breakpoints: { up }, colors, spacing }: Theme) => css`
  background-color: ${colors.bgLighter};
  margin-bottom: ${spacing(5)}px;
  padding: ${spacing(3)}px ${spacing(2.5)}px;

  ${up('md')} {
    margin-bottom: ${spacing(4.5)}px;
    padding: ${spacing(3)}px 0 ${spacing(5)}px;
  }
  ul {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: ${spacing(2.5)}px;
    ${up('md')} {
      flex-direction: row;
      margin-top: ${spacing(4)}px;
    }
    & > li {
      align-items: center;
      display: flex;
      & + li {
        margin-top: ${spacing(2.5)}px;
      }
      ${up('md')} {
        flex-direction: column;
        flex-grow: 1;
        max-width: 25%;
        & + li {
          border-left: 1px solid ${colors.borderDefault};
          margin-top: 0;
        }
      }
    }
  }
`;

export const cardTitleStyle = ({ breakpoints, spacing }: Theme) => css`
  ${breakpoints.up('md')} {
    padding: 0 ${spacing(3)}px;
  }
`;

export const cardSubTitleStyle = () => css`
  display: inline-block;
`;

export const textLinkStyle = ({ colors, interactiveStates }: Theme) => css`
  color: ${colors.fgPrimaryBase};
  cursor: pointer;
  ${interactiveStates.hover(css`
    text-decoration: underline;
  `)}
`;

export const cardIconDesktopStyle = (theme: Theme) => css`
  display: none;
  ${theme.breakpoints.up('md')} {
    display: block;
  }
  margin-bottom: ${theme.spacing(1.5)}px;
`;

export const cardIconMobileStyle = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  ${theme.breakpoints.up('md')} {
    display: none;
  }
  margin-right: ${theme.spacing(2)}px;
`;

export const dialogIconStyle = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  margin-right: ${theme.spacing(1)}px;
`;

export const dialogMeasuresSectionStyle = ({ breakpoints, spacing }: Theme) => css`
  & + * {
    margin-top: ${spacing(2)}px;
    ${breakpoints.up('md')} {
      margin-top: ${spacing(4)}px;
    }
  }
  li {
    line-height: 1.6;
    list-style: disc;
    margin-left: calc(${spacing(1)}px + 2.6rem + 2rem);
  }
`;

export const dialogMeasureTitleStyle = ({ spacing }: Theme) => css`
  align-items: center;
  display: flex;
  margin-bottom: ${spacing(1)}px;
`;

export const linkToClearEnclosingPStyle = ({ breakpoints, spacing }: Theme) => css`
  margin-bottom: ${spacing(0.5)}px;

  ${breakpoints.up('md')} {
    margin-bottom: ${spacing(1)}px;
  }
`;
